import type { ComponentType } from 'react';
import type { CampaignCarsUpProps, CampaignCarsUpVariants } from './types';

import { CampaignCardsInfo } from './info';
import { CampaignCards2up } from './2up';
import { CampaignCards3up } from './3up';
import { CampaignCards4up } from './4up';

const components = {
    info: CampaignCardsInfo,
    '2up': CampaignCards2up,
    '3up': CampaignCards3up,
    '4up': CampaignCards4up,
} as Record<CampaignCarsUpVariants, ComponentType<CampaignCarsUpProps>>;

export function CampaignCardsUp(props: CampaignCarsUpProps) {
    const Component = components[props.variant] ?? 'div';

    return <Component {...props} />;
}
